import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps, PrismicRichText } from '@prismicio/react';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { Heading } from '@/components/common/Heading';

/**
 * Props for `SideMediaCta`.
 */
export type SideMediaCtaProps = SliceComponentProps<Content.SideMediaCtaSlice>;

/**
 * Component for "SideMediaCta" Slices.
 */
const SideMediaCta: FC<SideMediaCtaProps> = ({ slice }) => {
  const { title, description, media_items, cta } = slice.primary;
  const mainImage = media_items?.[0]?.media_image;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-gradient-to-br from-primary-green-dark-1 to-primary-green-darker py-20 text-white"
    >
      <div className="container mx-auto grid grid-cols-1 items-center gap-12 px-4 md:grid-cols-2">
        {/* Media Column */}
        <div className="flex justify-center">
          {mainImage && (
            <PrismicNextImage
              field={mainImage}
              className="rounded-lg object-cover"
              fallbackAlt=""
            />
          )}
        </div>

        {/* Content Column */}
        <div className="text-center md:text-left">
          <Heading as="h2" size="6xl" className="mb-4">
            <PrismicRichText field={title} />
          </Heading>
          <div className="mx-auto mb-8 max-w-xl text-lg text-gray-200">
            <PrismicRichText field={description} />
          </div>
          <PrismicNextLink field={cta} className="secondary-button">
            Get Top Talent
          </PrismicNextLink>
        </div>
      </div>
    </section>
  );
};

export default SideMediaCta;
